<div class="full-height layout-row layout-align-start-center">
  <app-bringoz-checkbox
    [isChecked]="isSelected"
    [isDisabled]="!document?.attachment?.url"
    (clickEvent)="onSelect.emit(document); $event.stopPropagation()">
  </app-bringoz-checkbox>

  <span class="br-body-2">{{ documentSettings?.name }}</span>
  <span class="flex"></span>

  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner-border text-primary" role="status" style="width: 20px; height: 20px;">
    </div>
  </div>

  <app-attachment-popup *ngIf="document && !isLoading"
                        class="margin-right-5"
                        [link]="document.attachment.url"
                        [type]="document.attachment.mimeType"
                        [blobName]="document.attachment.name">
  </app-attachment-popup>

  <ng-container *ngIf="!document && !isLoading">
    <ng-container *ngxPermissionsOnly="permissionUpdate">
      <label for="file-upload-new" class="br-body-2 font-weight-400 blue-102 pointer">
        <bringoz-icon iconName="upload" fill="#266AFF" class="margin-right-5"></bringoz-icon>
      </label>
      <input type="file" id="file-upload-new"
             style="display: none;"
             (change)="uploadDocument($event.target.files)"/>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="document && !isLoading">
    <ng-container *ngxPermissionsOnly="permissionUpdate">
      <label for="file-upload-update" class="br-body-2 font-weight-400 blue-102 pointer">
        <bringoz-icon iconName="upload" fill="#266AFF" class="margin-right-5"></bringoz-icon>
      </label>
      <input type="file" id="file-upload-update" style="display: none;"
             (change)="updateDocument($event.target.files)"/>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="document && !isLoading">
    <ng-container *ngxPermissionsOnly="permissionDelete">
      <bringoz-icon iconName="trash" fill="#266AFF" class="margin-right-5 pointer"
                    (click)="onDeleted.emit(document)"></bringoz-icon>
      <!--        <span class="br-body-2 font-weight-400 blue-102 pointer" (click)="onDeleted.emit(document)" translate></span>-->
    </ng-container>
  </ng-container>
</div>
